module.exports = __webpack_public_path__ + "media/fonts/SARAH_SCRIPT-a5ab19aa9469e25db98d738da9dde56b.OTF";